export default "__VITE_ASSET__CrTsjLFf__"